import { useCleanText } from "@/shared/client";
import { type MainInfoDmaxResponse } from "@/shared/server";
import { removeHtmlTags } from "@/utils";
import { Box, Flex } from "@chakra-ui/react";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { CustomBox, CustomContainer, CustomText, CustomTitle } from "./banner.style";

export const Banner = ({ sector }: MainInfoDmaxResponse) => {
    const { main, sub } = sector;
    // const { isTablet } = MEDIA();
    const { cleanText } = useCleanText(sub.secondLine);
    // const vimeoValue = useVimemoValue();

    return (
        <CustomContainer position="relative" w="100%" maxW="100%" p="0" m="0">
            <Flex
                w="100%"
                maxW="1600px"
                flexDir="column"
                position="absolute"
                rowGap="16px"
                left="0"
                bottom="0"
                textShadow="1px 0 3px rgba(0, 0, 0, 0.4)"
                pointerEvents="none"
                zIndex="1"
                p="56px 0 40px 0"
            >
                <Box>
                    <CustomTitle as="h2">{removeHtmlTags(main.firstLine, "<br>").cleanText}</CustomTitle>
                    <CustomTitle as="h2">{removeHtmlTags(main.secondLine, "<br>").cleanText}</CustomTitle>
                </Box>
                <CustomBox>
                    <CustomText mb="4px">{sub.firstLine}</CustomText>
                    <CustomText>
                        <Flex flexDir="column" gap="4px">
                            {Array.isArray(cleanText) ? cleanText.map((text) => <p key={text}>{text}</p>) : cleanText}
                        </Flex>
                    </CustomText>
                </CustomBox>
            </Flex>
        </CustomContainer>
    );
};
